export default __webpack_public_path__ + "static/media/consulting.84e79318.svg";